import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import * as CryptoJS from 'crypto-js';
import { Globals } from '.././globals';


@Injectable()
export class facultyService {
  user:any;
  constructor(private http: HttpClient,private _global:Globals) {
   
  }
   readonly rootUrl = this._global.siteUrl;
    addfaculty(facultyObj){


        return this.http.post(this.rootUrl + 'faculty/addfaculty', facultyObj);
    }

    getfacultylist(start,end,searchtxt,typetxt,user){
      //console.log('test'+typetxt);
      var center = user.centerId;
      return this.http.get(this.rootUrl+"faculty/getfaculty?start="+start+"&end="+end+'&search='+searchtxt+'&Ftype='+typetxt+'&center='+center);
  
    }
    editfaculty(facultyId){
      return this.http.get(this.rootUrl+"faculty/geteditfaculty?cid="+btoa(facultyId));
    }
    
    posteditfaculty(facultyObj,facultyId){
      const body = {
        FirstName: facultyObj.FirstName,
        LastName:facultyObj.LastName,
        HiddenName:facultyObj.HiddenName,
        Center:facultyObj.Center,
        Type:facultyObj.Type,
        Email:facultyObj.Email,
        Mobile:facultyObj.Mobile,
        Status:facultyObj.Status,
        createdBy:facultyObj.userid,
        userId:facultyId,
        userType:facultyObj.userType,
        intro:facultyObj.intro,
        skills:facultyObj.skills,
        workedAt:facultyObj.workedAt,
        workingAt:facultyObj.workingAt,
        fromAddress:facultyObj.fromAddress,
        education:facultyObj.education,
        streamId:facultyObj.stream,
      }
     return this.http.post(this.rootUrl + 'faculty/editfaculty', body);
    }
 
    delfaculty(facultyId){
      const body = {
       id: facultyId,
       deleted:1
     }
     return this.http.post(this.rootUrl + 'faculty/delfaculty', body);
    }

    userfaculty(facultyId){
      return this.http.get(this.rootUrl+'faculty/getfacultylist?cid='+btoa(facultyId));
    }

    facultyprofile(Id){

      var reqHeader = new HttpHeaders({ 'No-Auth':'True'});
      const body = {
        id: Id,
      }
      return this.http.post(this.rootUrl + 'faculty/facultyprofile', body,{ headers: reqHeader});
    }
}


// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/service/faculty.service.ts